import moment from 'moment';

const isFormat = (format: string, date: string, locale?: string) =>
  moment(date, format, locale || 'en', true).isValid();

export default isFormat;
